import Component from './OneTimeEducationModal'

export default Component
